import { api } from "./api";

export const listarRecursos = (status) =>
  api.get(`/recurso/listar${status ? `?status=${status}` : ""}`);
export const obterRecurso = (id) => api.get(`/recurso/${id}`);
export const analisarRecurso = (id, dto) => api.post(`/recurso/analisar/${id}`, dto);
